export { default } from './PrepareDisclosuresWizardBody';
